// Standalone Input. For inputs with adornments (icons, buttons, prefix/suffix text),
// compose with InputGroup instead of extending this component.
import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const inputVariants = cva(
  'flex w-full min-w-0 border border-neutral-ui-border bg-app ' +
    'text-primary-high-contrast placeholder:text-text-body ' +
    'selection:bg-primary selection:text-primary-foreground ' +
    'transition-[color,box-shadow,border-color] outline-none ' +
    'hover:border-neutral-hover-border ' +
    'focus-visible:border-2 focus-visible:border-primary-ui-border ' +
    'aria-invalid:border-destructive ' +
    'disabled:bg-neutral-subtle-bg disabled:border-neutral-subtle-border disabled:opacity-60 disabled:cursor-not-allowed disabled:pointer-events-none ' +
    'file:inline-flex file:border-0 file:bg-transparent file:font-medium file:text-foreground',
  {
    variants: {
      size: {
        sm: 'h-6 rounded-md px-2 text-xs gap-1.5 file:h-5',
        default: 'h-8 rounded-lg px-3 text-sm gap-2 file:h-7',
        lg: 'h-10 rounded-lg px-4 text-base gap-3 file:h-9',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)

function Input({
  className,
  size,
  type,
  ...props
}: Omit<React.ComponentProps<'input'>, 'size'> &
  VariantProps<typeof inputVariants>) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size ?? 'default'}
      className={cn(inputVariants({ size }), className)}
      {...props}
    />
  )
}

export { Input, inputVariants }
